/**
 * LangChip.tsx — 语言徽章（移植自原型 primitives.jsx §2.2 LangChip）
 *
 * 渲染 <大写 CODE> + 中文名 胶囊。中文名统一走 ~/lib/format 的 langName(code)（权威 LANG_NAMES），
 * 等价于原型里的 window.langName；调用方可传 zh 显式覆盖中文名（含传空串以隐藏）。
 */

import type { CSSProperties } from 'react';
import { langName } from '~/lib/format';

export interface LangChipProps {
  /** 语言代码，渲染时大写；如 "en" → "EN" */
  code?: string;
  /** 中文名覆盖；缺省走 langName(code)；传空串可隐藏中文名 */
  zh?: string;
  style?: CSSProperties;
}

export function LangChip({ code, zh, style }: LangChipProps) {
  const name = zh !== undefined ? zh : langName(code);
  return (
    <span className="chip" style={style}>
      <span className="mono">{String(code || '').toUpperCase()}</span>
      {name && <span style={{ color: 'var(--fg-faint)', marginLeft: 4 }}>{name}</span>}
    </span>
  );
}
